import React from "react";
import "./noUser.scss";

const NoUser: React.FC = () => {
  return (
    <div className="centered-text">
      <p>No chat selected</p>
    </div>
  );
};

export default NoUser;
